<template>
  <div class="bt-bg">
    <div class="bt-con">
      <span>{{ $t('q_a.hot_line')}}</span>
      <ul class="icon-list">
        <li
          v-for="(item, index) in iconList"
          :key="index"
          :class="item.backColor"
          :style="{ background: item.backColor }"
        >
          <a :href="item.toLink">
            <i :class="['icon', 'iconfont', item.icon]"></i>
          </a>
        </li>
      </ul>
      <!-- <span>ENG 繁體中文</span> -->
    </div>
    <p class="tips">
      <!-- Copyright | Privacy Policy | Term of Use -->
      <a target="_blank" href="http://inspiringhk.org/#/inspiringHk/copyroght"
        >Copyright |</a
      >
      <a target="_blank" href="http://inspiringhk.org/#/inspiringHk/privacy">
        Privacy Policy |</a
      >
      <a
        target="_blank"
        href="http://inspiringhk.org/#/inspiringHk/term-of-use"
      >
        Term of Use</a
      >
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      iconList: [
        {
          icon: "icon-Facebook",
          toLink: "https://www.facebook.com/ihksports/",
          backColor: "#37589a",
        },
        {
          icon: "icon-instagram",
          toLink: "https://www.instagram.com/ihksports/",
          backColor: "#336d96",
        },
        {
          icon: "icon-linkedin1",
          toLink: "https://www.linkedin.com/company-beta/3766637/",
          backColor: "#1f81ef",
        },
        {
          icon: "icon-youtube3",
          toLink: "https://www.youtube.com/channel/UCaUTwxuFhaqfLTmnreBFjrg",
          backColor: "red",
        },
        {
          icon: "icon-mail1",
          toLink: "mailto:info@inspiringhk.org",
          backColor: "#2b894a",
        },
        {
          icon: "icon-pin",
          toLink: "https://www.facebook.com/ihksports/",
          backColor: "#d6544d",
        },
      ],
    };
  },
  methods: {
    getImgUrl(path) {
      return require("../assets/img/home/" + path + ".png");
    },
  },
};
</script>

<style lang="scss" scoped>
.bt-bg {
  margin: 0 auto;
  background: #229fd9;
  height: 110px;
  width: 100%;
  color: #fff;
  z-index: 1;
  position: relative;
  .bt-con {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px 0 10px;
    font-size: 14px;
    .icon-list {
      display: flex;
      margin: 0 auto;
      width: 360px;
      justify-content: space-between;
      & > li {
        cursor: pointer;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        margin: 0 10px;
      }
    }
  }
  .tips {
    text-align: center;
    font-size: 13px;
  }
}
@media (max-width: 768px) {
  .bt-bg {
    .bt-con {
      padding: 3vw;
      align-items: center;
      .icon-list {    
        width: 100%;
        margin: 5px auto;
        & > li {
          width: 30px;
          height: 30px;
          line-height: 30px;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>
